var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("main", { staticClass: "page-live-reservation-hsylc" }, [
      _c("img", {
        attrs: {
          src:
            "https://summer-storage.oss-cn-shanghai.aliyuncs.com/BPC2026/live/hsylc-cover.jpg",
          alt: "HSYLC 直播预约海报"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }